import type { UseQueryResult } from '@tanstack/react-query';
import type { JSX, ReactNode } from 'react';

import { Alert } from './Alert.tsx';
import { hintClass } from './styles.ts';

export interface LoadedProps<T> {
  readonly query: UseQueryResult<T>;
  /** What to say while it loads. */
  readonly loading: string;
  /** What to say when it failed, including what the reader can do about it. */
  readonly error: string;
  readonly children: (data: T) => ReactNode;
}

/** Pending, error and success, stated once so no screen can forget one of them. */
export function Loaded<T>({ query, loading, error, children }: LoadedProps<T>): JSX.Element {
  if (query.isPending) {
    return <p className={hintClass}>{loading}</p>;
  }
  if (query.isError) {
    return <Alert>{error}</Alert>;
  }
  return <>{children(query.data)}</>;
}
